var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPayoutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4833_2554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z",
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39539 8.60322H13.428L13.1534 9.65423H12.0845H11.9944L12.042 9.73068C12.1985 9.98167 12.2999 10.264 12.3457 10.5801L12.3519 10.6229H12.3952H13.4213L13.1468 11.6739H12.3835H12.3411L12.3342 11.7158C12.252 12.2137 12.062 12.6167 11.7659 12.9291C11.4694 13.2418 11.0452 13.4837 10.4913 13.6523L10.42 13.674L10.4671 13.7318L12.6726 16.4359V16.45H10.6929L8.21363 13.4898L8.20894 12.5039H9.44669V12.504L9.44766 12.5039C9.71505 12.4988 9.93991 12.4333 10.1184 12.304C10.297 12.1746 10.4248 11.9844 10.5033 11.7374L10.5241 11.6722H10.4557H8.06474L8.33931 10.6212H10.4139H10.4922L10.4593 10.5502C10.375 10.3685 10.25 10.2289 10.0841 10.1334C9.91875 10.0383 9.71551 9.98853 9.47652 9.98167L9.47652 9.98165H9.47509H8.06987L8.39539 8.60322Z",
    fill: "#FFEFDE",
    stroke: "#FAAA52",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0842 2.56737C15.7852 2.25637 15.2632 2.47037 15.2632 2.90137V5.53837C15.2632 6.64437 16.1742 7.55437 17.2802 7.55437C17.9772 7.56237 18.9452 7.56437 19.7672 7.56237C20.1882 7.56137 20.4022 7.05837 20.1102 6.75437C19.0552 5.65737 17.1662 3.69137 16.0842 2.56737Z",
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#FAAA52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1515 19C17.1054 19 17.0622 18.9925 17.0219 18.9776C16.9816 18.9627 16.9442 18.9374 16.9096 18.9016L15.4241 17.3624C15.3608 17.2968 15.3306 17.2118 15.3334 17.1074C15.3363 17.003 15.3694 16.918 15.4328 16.8523C15.4961 16.7867 15.5767 16.7539 15.6746 16.7539C15.7725 16.7539 15.8531 16.7867 15.9164 16.8523L17.1515 18.132L20.0793 15.0984C20.1426 15.0328 20.2247 15 20.3254 15C20.4262 15 20.5082 15.0328 20.5716 15.0984C20.6349 15.1641 20.6666 15.2491 20.6666 15.3535C20.6666 15.4579 20.6349 15.5429 20.5716 15.6085L17.3933 18.9016C17.3587 18.9374 17.3213 18.9627 17.281 18.9776C17.2407 18.9925 17.1975 19 17.1515 19Z",
    fill: "#FFEFDE",
    stroke: "#FFEFDE",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4833_2554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayoutActive);
export default __webpack_public_path__ + "static/media/Icon.PayoutActive.68a611966afa9657855d2996633e4773.svg";
export { ForwardRef as ReactComponent };